@if (product$) {
<div class="notify-me-modal-container">
  <div class="modal-container">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          {{ 'stockNotification.outOfStockItemsLabel' | cxTranslate }}
        </h4>
      </div>
      <div class="modal-body">
        @for (product of product$; track product; let productIndex = $index) {
        <div class="product-info">
          <div class="image">
            @if (product?.images) {
            <cx-media
              [container]="getImageRendition(product.images?.PRIMARY)"
              format="product"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            } @else {
            <cx-media
              class="cx-no-image is-missing"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            }
          </div>
          <div class="entry-info">
            <div class="code">
              {{ product.code }}
            </div>
            <div class="name" [innerHTML]="product.name"></div>
          </div>
        </div>
        @if (variant$) {
        <div class="table">
          <div class="table-container">
            <hr />
            <div class="header-container">
              @if (showCategory) { @for (headerName of categoryNames[productIndex]; track headerName) {
              <div class="header">
                <span>{{ headerName }}</span>
              </div>
              } } @if (!showSrp) {
              <div class="header">
                <span>{{ 'stockNotification.priceLabel' | cxTranslate }}</span>
              </div>
              }
              <div class="header">
                <span>{{ 'stockNotification.notifyMeLabel' | cxTranslate }}</span>
              </div>
            </div>
            <hr />
            @for (variant of variant$; track variant) { @if (compareCodes(variant?.superCategories,
            product?.superCategories, product)) {
            <div class="categories-info-container">
              @if (showCategory) { @for ( variantCategoryValue of productCategories( variant.superCategories,
              categoryNames[productIndex] ) ; track variantCategoryValue) {
              <div class="product-categories">
                <div class="value">
                  {{ variantCategoryValue }}
                </div>
              </div>
              } } @if (!showSrp) {
              <div class="product-price">
                <div class="value">
                  {{ dealerPrice(variant.code) }}
                </div>
              </div>
              }
              <div class="notify-me">
                <div class="value">
                  <app-notify-me [productCode]="variant.code" [isModal]="true"></app-notify-me>
                </div>
              </div>
            </div>
            <hr />
            } }
          </div>
        </div>
        } }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn secondary-btn cancel-btn mw-120" (click)="closeModal('Cross click')">
          {{ 'modal.close' | cxTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>
}
